import React from "react";
import { Link } from "react-router-dom";
import { WaldLogo } from "./WaldLogo";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-background">
      <div className="container-wald py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <WaldLogo />
            <p className="mt-5 max-w-md text-sm opacity-70 leading-relaxed">
              The specialist technology partner for South African agricultural exporters, packhouses,
              grower organisations and regulated operations.
            </p>
            <div className="mt-6 space-y-2 text-sm opacity-80">
              <div className="flex items-center gap-2"><MapPin size={14} strokeWidth={2} /> Pretoria, South Africa</div>
              <div className="flex items-center gap-2"><Mail size={14} strokeWidth={2} /> info@wald.co.za</div>
              <div className="flex items-center gap-2"><Phone size={14} strokeWidth={2} /> +27 (0)71 336 0548</div>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-svc-dt" to="/services/digital-transformation" className="nav-link">Digital Transformation</Link></li>
              <li><Link data-testid="footer-svc-ai" to="/services/ai-automation" className="nav-link">AI & Automation</Link></li>
              <li><Link data-testid="footer-svc-cs" to="/services/custom-software" className="nav-link">Custom Software</Link></li>
              <li><Link data-testid="footer-svc-pe" to="/services/platform-engineering" className="nav-link">Platform Engineering</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow mb-4">Industries</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/industries/agricultural-exporters" className="nav-link">Exporters</Link></li>
              <li><Link to="/industries/packhouses" className="nav-link">Packhouses</Link></li>
              <li><Link to="/industries/grower-organisations" className="nav-link">Growers</Link></li>
              <li><Link to="/industries/export-agents" className="nav-link">Agents</Link></li>
              <li><Link to="/industries/regulated-organisations" className="nav-link">Regulators</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow mb-4">Products</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products/agribrain-360" className="nav-link">AgriBrain 360</Link></li>
              <li><Link to="/products/certisfy" className="nav-link">Certisfy</Link></li>
              <li><Link to="/products/waldinsights" className="nav-link">WaldInsights</Link></li>
              <li><Link to="/products/waldflow" className="nav-link">WaldFlow</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="eyebrow mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="nav-link">About</Link></li>
              <li><Link to="/insights" className="nav-link">Insights</Link></li>
              <li><Link to="/contact" className="nav-link">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="rule mt-12" />
        <div className="mt-6 flex flex-col md:flex-row justify-between gap-3 text-xs opacity-60">
          <div>© {year} Wald Enterprise. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="nav-link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="nav-link">Terms of Use</Link>
            <span>POPIA compliant</span>
            <span>South Africa</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
